import { MineAreaShiftSchedule } from '@/models/api';
import _ from 'lodash';
import { Dayjs } from 'dayjs';

export function GetRepresentativeShifts(shiftSchedule: MineAreaShiftSchedule) {
    if(!HasRegularShiftStructure(shiftSchedule)) return null;

    return [...shiftSchedule.days[0].slots].sort((a, b) => a.shiftNumber - b.shiftNumber);
}

export function HasRegularShiftStructure(shiftSchedule: MineAreaShiftSchedule) {
    const firstDaySchedule = shiftSchedule.days[0];
    const firstDaySlotsOrdered = [...firstDaySchedule.slots].sort((a, b) => a.shiftNumber - b.shiftNumber);

    return shiftSchedule.days.every(day=>{
        return day.slots.length === firstDaySchedule.slots.length
        && _.zip([...day.slots].sort((a, b) => a.shiftNumber - b.shiftNumber), firstDaySlotsOrdered).every(([a, b])=>{
            return a!.shiftNumber === b!.shiftNumber
            && a!.durationMinutes === b!.durationMinutes
            && a!.name === b!.name;
        });
    })
}

export function GetMostShiftsInDay(shiftSchedule: MineAreaShiftSchedule) {
    return _.max(shiftSchedule.days.map(d=>_.max(d.slots.map(s=>s.shiftNumber))));
}

export function GetShiftNameWithNumericFallback(shiftSchedule: MineAreaShiftSchedule, shiftNumber: number) {
    const names = shiftSchedule.days.flatMap(d=>d.slots.filter(s=>s.shiftNumber === shiftNumber).map(s=>s.name));
    const uniqueNames = _.uniq(names);
    if(uniqueNames.length === 1) return uniqueNames[0];
    return `${shiftNumber}`;
}

export function GetDayScheduleSlots(shiftSchedule: MineAreaShiftSchedule, day: Dayjs){
    const schedule = GetDaySchedule(shiftSchedule, day);

    return schedule != null ? [...schedule.slots].sort((a, b) => a.shiftNumber - b.shiftNumber) : null;
}

export function GetDaySchedule(shiftSchedule: MineAreaShiftSchedule, day: Dayjs) {
    return shiftSchedule.days.find(d=>d.dayOfWeek === day.day());
}